'use client';
import { useQuery } from '@tanstack/react-query';
import styled from 'styled-components';
import { useParams } from 'next/navigation';

import { callService } from '@api/remote-call';
import Markdown from '@components/utils/Markdown';
import { Layout as DefaultLayout } from '@components/formStyles';

const Wrapper = styled.div`
  padding: 20px;
  width: 100%;
  .box-shadow {
    margin: 5px !important;
    border-radius: 8px !important;
  }
  & img {
    border-radius: 8px;
    overflow: hidden;
  }
  .card-img-top {
    border-radius: 8px 8px 0px 0px !important;
  }
  *,
  :after,
  :before {
    border-radius: 8px;
  }
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.DESKTOP})`} {
    padding: 0px;

    & iframe {
      height: auto !important;
      max-height: 100% !important;
    }
    .slider {
      width: 100% !important;
    }
    .row {
      display: inline !important;
      width: 100% !important;
    }
    .col-md-6 {
      max-width: 100% !important;
      width: 100% !important;
    }
    .h2-style {
      max-width: 100% !important;
    }
    & div {
      width: 100% !important;
      max-width: 100% !important;
    }
    & img {
      width: 100% !important;
      max-width: 100% !important;
      margin-left: 0px;
    }
    .box-shadow {
      margin: 0px !important;
    }
  }
`;
export const Layout = styled(DefaultLayout)`
  min-height: 320px;
`;
const WrapperEthic = styled.div`
  padding: 20px;
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    padding: 0px;
  }
`;
const Div = styled.div`
  -webkit-user-select: none;
  -webkit-touch-callout: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
`;

const AnnouncementPage = () => {
  const params = useParams();

  const { data } = useQuery(['static', JSON.stringify(params)], () =>
    callService(
      { service: 'ContentsService', method: 'getMeta', version: 'v3' },
      {
        slug: params?.slug as string,
      }
    )
  );

  return (
    <div>
      {params?.slug === 'setur-etik-ilkeler' ? (
        <WrapperEthic>
          <Div>
            <Markdown text={data?.content} />
          </Div>
        </WrapperEthic>
      ) : (
        <Wrapper>
          <Layout>
            <Markdown text={data?.content} />
          </Layout>
        </Wrapper>
      )}
    </div>
  );
};

export default AnnouncementPage;
